import React from "react";

const SandwichAbsent = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M18.439 22.194V34H3c0-1.86.43-3.697 1.26-5.368a12.224 12.224 0 0 1 3.526-4.272 12.427 12.427 0 0 1 5.072-2.303 12.509 12.509 0 0 1 5.58.137Zm-3.088-1.908c-5.118 0-9.263-4.092-9.263-9.143C6.088 6.09 10.233 2 15.35 2s9.263 4.091 9.263 9.143c0 5.051-4.145 9.143-9.263 9.143Zm9.263 6.095v-4.572h3.088v4.572h4.631v3.048h-4.631V34h-3.088v-4.571h-4.631V26.38h4.631Z"
        />
    </svg>
);

export default SandwichAbsent;